module.exports = __webpack_public_path__ + "img/elm-unicom.d91c4825.png";